<template>
  <div>
    <v-dialog
      v-model="loading"
      persistent
      width="300"
    >
      <v-card
        color="white">
        <v-card-text>
          Loading Template Editor
          <v-progress-linear
            indeterminate
            color="blue"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <div
      class="block-header"
    >
      <v-layout
        row wrap
      >
        <v-flex
          sm12
          md6
        >
          <div>
            <h4>Editing Form Template</h4>
            <h2>{{ template.name }}</h2>
          </div>
        </v-flex>
        <v-flex
          sm12
          md6
          style="text-align:center;"
        >
          <v-btn
            flat
            small
            @click="editing=true"
          >
            <v-icon>mdi-file-cog</v-icon>&nbsp;
            Settings
          </v-btn>
          <v-menu offset-y>
            <template slot="activator">
              <v-btn
                flat
                small
              >
                <v-icon>mdi-file-export</v-icon>&nbsp;
                Download Import File
              </v-btn>
            </template>
            <v-list>
              <v-list-tile
                @click="downloadImportGrid('create')"
              >
                <v-list-tile-content>
                  <v-list-tile-title>Create Forms</v-list-tile-title>
                  <v-list-tile-sub-title>Contact ID Required for New Forms</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                @click="downloadImportGrid('update')"
              >
                <v-list-tile-content>
                  <v-list-tile-title>Update Forms</v-list-tile-title>
                  <v-list-tile-sub-title>Form ID Required for Existing Forms</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn
            flat
            small
            v-if="!viewArchived"
            @click="$store.state.formtemplate.viewArchived=true"
          >
            <v-icon>unarchive</v-icon>&nbsp;
            Show Archived
          </v-btn>
          <v-btn
            small
            v-else
            @click="$store.state.formtemplate.viewArchived=false"
          >
            <v-icon>archive</v-icon>&nbsp;
            Hide Archived
          </v-btn>
          <v-btn
            :flat="!viewIdentifiers"
            small
            @click="$store.state.formtemplate.viewIdentifiers=!$store.state.formtemplate.viewIdentifiers"
          >
            <v-icon>{{ viewIdentifiers ? 'label_off' : 'label' }}</v-icon>&nbsp;
            {{ viewIdentifiers ? 'Hide IDs' : 'Show IDs' }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div
      v-if="!loading"
      style="margin-top: 25px;"
    >
      <v-dialog
        v-model="editing"
        width="1024"
        height="700"
        scrollable
        persistent
      >
        <v-card>
          <v-toolbar
            color="primary"
            dark
            flat
            dense
          >
            {{edittemplate.name}} Options
          </v-toolbar>
          <v-card-text
            style="min-height:550px;"
          >
            <v-layout row>
              <v-flex sm3>
                <v-list>
                  <v-list-tile
                    avatar
                    :class="{ active: editFocus == 'general'}"
                    @click="editFocus='general'"
                  >
                    <v-list-tile-avatar>
                      <v-icon>settings</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>General</v-list-tile-title>
                      <v-list-tile-sub-title>General Settings</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile
                    avatar
                    :class="{ active: editFocus == 'case'}"
                    @click="editFocus='case'"
                  >
                    <v-list-tile-avatar>
                      <v-icon>mdi-briefcase</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Case Type</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile
                    avatar
                    :class="{ active: editFocus == 'notification'}"
                    @click="editFocus='notification'"
                  >
                    <v-list-tile-avatar>
                      <v-icon>mdi-bell-ring</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Notifications</v-list-tile-title>
                      <v-list-tile-sub-title>Messages &amp; Reminders</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile
                    avatar
                    :class="{ active: editFocus == 'pdf'}"
                    @click="editFocus='pdf'"
                  >
                    <v-list-tile-avatar>
                      <v-icon>description</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>PDF</v-list-tile-title>
                      <v-list-tile-sub-title>Submission &amp; Header</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile
                    avatar
                    :class="{ active: editFocus == 'esign'}"
                    @click="editFocus='esign'"
                  >
                    <v-list-tile-avatar>
                      <v-icon>mdi-signature-freehand</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>E-signature</v-list-tile-title>
                      <v-list-tile-sub-title>Signature Properties</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex
                sm9
                style="padding:10px;"
              >
                <div
                  v-show="editFocus=='general'"
                >
                  <v-text-field
                    v-model="edittemplate.name"
                    label="Template Name"
                    autofocus
                  />
                  <v-checkbox
                    v-model="edittemplate.hide_from_contact"
                    label="Hide Forms From Contacts"
                  />
                </div>
                <div
                  v-show="editFocus=='case'"
                >
                  <v-alert
                    type="warning"
                    :value="true"
                  >
                    Associating {{ edittemplate.name }} with add it to the Case Type's quick add list.
                  </v-alert>
                  <v-autocomplete
                    v-if="!edittemplate.case_type"
                    v-model="edittemplate.case_type"
                    :items="casetypeResults"
                    :search-input.sync="casetypeSearch"
                    label="Case Type"
                    item-text="name"
                    item-value="id"
                    :return-object="false"
                    flat
                    @input="casetypeSearch = ''"
                  />
                  <CaseTypePreview
                    v-else
                    :id="edittemplate.case_type"
                  />
                </div>
                <div
                  v-if="editing"
                  v-show="editFocus=='notification'"
                  style="scroll-y: auto;max-height: 60vh;"
                >
                  <v-alert
                    :value="true"
                    type="info"
                    outline
                  >
                    Send automatic messages or reminders to comlete this form.
                  </v-alert>
                  <br />
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator">
                      <v-text-field
                        v-model="edittemplate.stop_notifying_date"
                        label="Reminder End Date (Required)"
                        prepend-icon="event"
                        required
                        mask="####-##-##"
                        placeholder="YYYY-MM-DD"
                        return-masked-value
                        readonly
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="edittemplate.stop_notifying_date"
                      @input="dateMenu = false"
                      landscape
                    />
                  </v-menu>
                  <v-checkbox
                    v-model="edittemplate.notify_on_add"
                    label="Send Notification when Added to Contact"
                    hide-details
                  />
                  <v-expand-transition>
                    <div
                      v-show="edittemplate.notify_on_add"
                      style="padding-left: 15px;margin-left: 12px;border-left: 1px solid rgba(0,0,0,0.2);"
                    >
                      <v-text-field
                        v-model="edittemplate.add_notification_subject"
                        label="Message Subject"
                        autofocus
                      />
                      <Editor
                        ref="addHtml"
                        :html="edittemplate.add_notification_message"
                        height="40"
                        :placeholders="placeholders"
                      />
                    </div>
                  </v-expand-transition>
                  <v-checkbox
                    v-model="edittemplate.notify_on_submit"
                    label="Send Notification when Submitted"
                    hide-details
                  />
                  <v-expand-transition>
                    <div
                      v-show="edittemplate.notify_on_submit"
                      style="padding-left: 15px;margin-left: 12px;border-left: 1px solid rgba(0,0,0,0.2);"
                    >
                      <v-text-field
                        v-model="edittemplate.submit_notification_subject"
                        label="Message Subject"
                        autofocus
                      />
                      <Editor
                        ref="submitHtml"
                        :html="edittemplate.submit_notification_message"
                        height="40"
                        :placeholders="placeholders"
                      />
                    </div>
                  </v-expand-transition>
                  <v-checkbox
                    v-model="edittemplate.notify_new"
                    label="Send Reminders when Unopened (New)"
                    hide-details
                  />
                  <v-expand-transition>
                    <div
                      v-show="edittemplate.notify_new"
                      style="padding-left: 15px;margin-left: 12px;border-left: 1px solid rgba(0,0,0,0.2);"
                    >
                      <v-layout
                        row
                      >
                        <v-flex
                          xs4
                          style="padding: 0px 5px 0px 5px;"
                        >
                          <v-text-field
                            v-model="edittemplate.new_notification_freq"
                            label="Reminder Frequency (Every 1-31 Days)"
                            type="number"
                            min="1"
                            max="31"
                          />
                        </v-flex>
                        <v-flex
                          xs4
                          style="padding: 0px 5px 0px 5px;"
                        >
                          <v-text-field
                            v-model="edittemplate.new_notification_max"
                            label="Maximum Reminders (1-10)"
                            type="number"
                            min="1"
                            max="10"
                          />
                        </v-flex>
                        <v-flex
                          xs4
                          style="padding: 0px 5px 0px 5px;"
                        >
                          <v-select
                            v-model="edittemplate.new_notification_time"
                            label="Hour to Send Reminder"
                            :items="hourArray"
                          />
                        </v-flex>
                      </v-layout>
                      <v-text-field
                        v-model="edittemplate.new_notification_subject"
                        label="Message Subject"
                        autofocus
                      />
                      <Editor
                        ref="newHtml"
                        :html="edittemplate.new_notification_text"
                        height="40"
                        :placeholders="placeholders"
                      />
                    </div>
                  </v-expand-transition>
                  <v-checkbox
                    v-model="edittemplate.notify_started"
                    label="Send Reminders when Started but left Unsubmitted (Client Started)"
                    hide-details
                  />
                  <v-expand-transition>
                    <div
                      v-show="edittemplate.notify_started"
                      style="padding-left: 15px;margin-left: 12px;border-left: 1px solid rgba(0,0,0,0.2);"
                    >
                      <v-layout
                        row
                      >
                        <v-flex
                          xs4
                          style="padding: 0px 5px 0px 5px;"
                        >
                          <v-text-field
                            v-model="edittemplate.started_notification_freq"
                            label="Reminder Frequency (Every 1-31 Days)"
                            type="number"
                            min="1"
                            max="31"
                          />
                        </v-flex>
                        <v-flex
                          xs4
                          style="padding: 0px 5px 0px 5px;"
                        >
                          <v-text-field
                            v-model="edittemplate.started_notification_max"
                            label="Maximum Reminders (1-10)"
                            type="number"
                            min="1"
                            max="10"
                          />
                        </v-flex>
                        <v-flex
                          xs4
                          style="padding: 0px 5px 0px 5px;"
                        >
                          <v-select
                            v-model="edittemplate.started_notification_time"
                            label="Hour to Send Reminder"
                            :items="hourArray"
                          />
                        </v-flex>
                      </v-layout>
                      <v-text-field
                        v-model="edittemplate.started_notification_subject"
                        label="Message Subject"
                        autofocus
                      />
                      <Editor
                        ref="startedHtml"
                        :html="edittemplate.started_notification_text"
                        height="40"
                        :placeholders="placeholders"
                      />
                    </div>
                  </v-expand-transition>
                  <v-checkbox
                    v-model="edittemplate.notify_signing"
                    label="Send Reminders when incomplete sign on submission (Client Signing)"
                    hide-details
                  />
                  <v-expand-transition>
                    <div
                      v-show="edittemplate.notify_signing"
                      style="padding-left: 15px;margin-left: 12px;border-left: 1px solid rgba(0,0,0,0.2);"
                    >
                      <v-layout
                        row
                      >
                        <v-flex
                          xs4
                          style="padding: 0px 5px 0px 5px;"
                        >
                          <v-text-field
                            v-model="edittemplate.signing_notification_freq"
                            label="Reminder Frequency (Every 1-31 Days)"
                            type="number"
                            min="1"
                            max="31"
                          />
                        </v-flex>
                        <v-flex
                          xs4
                          style="padding: 0px 5px 0px 5px;"
                        >
                          <v-text-field
                            v-model="edittemplate.signing_notification_max"
                            label="Maximum Reminders (1-10)"
                            type="number"
                            min="1"
                            max="10"
                          />
                        </v-flex>
                        <v-flex
                          xs4
                          style="padding: 0px 5px 0px 5px;"
                        >
                          <v-select
                            v-model="edittemplate.signing_notification_time"
                            label="Hour to Send Reminder"
                            :items="hourArray"
                          />
                        </v-flex>
                      </v-layout>
                      <v-text-field
                        v-model="edittemplate.signing_notification_subject"
                        label="Message Subject"
                        autofocus
                      />
                      <Editor
                        ref="signingHtml"
                        :html="edittemplate.signing_notification_text"
                        height="40"
                        :placeholders="placeholders"
                      />
                    </div>
                  </v-expand-transition>
                </div>
                <div
                  v-show="editFocus=='pdf'"
                >
                  <v-text-field
                    v-model="edittemplate.header_text"
                    label="Header Text"
                    hint="Replace tags: {form number} {party name} {template name} {case number} {case title}"
                    autofocus
                    :counter=pdfHeaderMaxChars
                  />
                  <v-text-field
                    v-model="edittemplate.submission_fill_blank"
                    label="On Submission: Replace Blank Answers"
                    hint="This will replace blank or unanswered questions with the text entered when downloading for submission."
                    autofocus
                  />
                  <v-checkbox
                    v-model="edittemplate.submission_min_rows"
                    label="Hide Empty Rows in Tables or Lists"
                  />
                </div>
                <div
                  v-show="editFocus=='esign'"
                >
                  <v-checkbox
                    v-model="edittemplate.sign_on_client_submit"
                    label="Sign on Submission"
                    :readonly="edittemplate.esign_provider == 'local'"
                    :disabled="edittemplate.esign_provider == 'local'"
                  />
                  <v-checkbox
                    v-model="override_default_esign"
                    :label="`Override Default Provider & Options`"
                    @change="updateOverride()"
                  />
                  <div
                    v-if="override_default_esign"
                    style="padding: 15px;background:rgba(0,0,0,0.05);border-radius: 10px;border: rgba(0,0,0,0.2) solid 1px;"
                  >
                    <v-select
                      v-model="edittemplate.esign_provider"
                      :items="getDomainInfo.esign_providers"
                      item-text="name"
                      item-value="key"
                      label="Esignature Provider"
                      @blur="updateEsign()"
                    />
                    <div
                      v-for="opt in selectedProviderOptions"
                    >
                      <v-text-field
                        v-if="opt.type == 'text' && showConditionalOption(opt)"
                        v-model="edittemplate.esign_template_settings[opt.key]"
                        :label="opt.name"
                        :hint="opt.hint"
                        persistent-hint
                      />
                    </div>

                    <v-alert
                      :value="edittemplate.esign_provider == 'local'"
                      type="warning"
                      dense
                    >
                      <b>Warning: Local Signing:</b><br />
                      - does not currently support additional signers.<br />
                      - uses a simple signature field, allowing the contact to sign with a draw field, or by adopting a font signature.<br />
                      - does not append the contact's name or date signed - you'll need to add those fields to your form.
                    </v-alert>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions
            style="background:lightgrey;"
          >
            <v-btn
              :disabled="saving"
              @click="editing=false"
              flat
            >
              Cancel
            </v-btn>
            <v-btn
              :disabled="saving"
              @click="copyDialog = true"
              flat
            >
              Duplicate Form
            </v-btn>
            <v-spacer/>
            <v-btn
              :disabled="!canYouSave"
              color="info"
              @click="save()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="copyDialog"
        persistent
        width="500"
      >
        <v-card>
          <v-toolbar
            dense
            color="primary"
            flat
            dark
          >
            <v-icon
              left
              size="14"
              style="padding-right: 10px;"
            >
              mdi-content-duplicate
            </v-icon>
            Duplicate {{template.name}}
          </v-toolbar>
          <v-card-text>
            <v-text-field
              v-model="duplicateName"
              label="New Template Name"
              :placeholder="`Copy of ${template.name}`"
            />
          </v-card-text>
          <v-card-actions
            style="background:lightgrey;"
          >
            <v-btn
              :disabled="saving"
              @click="copyDialog = false"
              flat
            >
              Cancel
            </v-btn>
            <v-spacer/>
            <v-btn
              :disabled="saving"
              color="info"
              @click="duplicateForm()"
            >
              Duplicate Form
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <Draggable
        v-model="template.root_parts"
        :options="{draggable:'.draggable-item', handle:'.handle', animation: 150, easing: 'cubic-bezier(1, 0, 0, 1)'}"
        class="root-parts"
        :move="drag"
        @end="endDrag"
      >
        <FormTemplatePart
          v-for="partId in template.root_parts"
          :key="partId"
          :partId="partId"
          class="draggable-item"
        />
        <div slot="footer">
          <v-btn
            v-if="!addingNewPart && template.id"
            color="white"
            @click="newSection"
          >
            <v-icon>add</v-icon>
            Add Section
          </v-btn>
          <v-btn
            v-if="!addingNewPart && template.id"
            color="white"
            @click="newParagraph"
          >
            <v-icon>add</v-icon>
            Add Paragraph
          </v-btn>
          <v-btn
            v-if="!addingNewPart && template.id"
            color="white"
            @click="newPageBreak"
          >
            <v-icon>add</v-icon>
            Add Page Break
          </v-btn>
          <FormTemplatePart
            v-if="addingNewPart"
            :newPart="newPart"
            @cancel="addingNewPart = false"
            @save="partAdded"
          />
        </div>
      </Draggable>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'
import Draggable from 'vuedraggable'
import FormTemplatePart from './FormTemplatePart'
import api from '@/api'
import Editor from '@/components/admin/Editor'
import CaseTypePreview from '@/components/admin/cases/CaseTypePreview'

export default {
  name: 'FormTemplate',
  components: {
    Draggable,
    FormTemplatePart,
    Editor,
    CaseTypePreview
  },
  data () {
    return {
      loading: false,
      edittemplate: {},
      editing: false,
      saving: false,
      duplicateName: null,
      casetypeSearch: null,
      casetypeResults: [],
      copyDialog: false,
      editFocus: 'general',
      hourArray: [],
      draggedElement: null,
      dateMenu: false,
      newPart: null,
      addingNewPart: false,
      override_default_esign: false,
      placeholders: [
        {
          scope: "contact",
          variable: "first_name",
          name: "Contact: First Name",
        },
        {
          scope: "contact",
          variable: "middle_name",
          name: "Contact: Middle Name",
        },
        {
          scope: "contact",
          variable: "last_name",
          name: "Contact: Last Name"
        },
        {
          scope: "contact",
          variable: "full_name",
          name: "Contact: Full Name (Last, Middle First)"
        },
        {
          scope: "contact",
          variable: "cuid",
          name: "Contact: CUID"
        },
        {
          scope: "contact",
          variable: "email",
          name: "Contact: Email"
        },
        {
          scope: "contact",
          variable: "phone",
          name: "Contact: Phone"
        }
      ],
      pdfHeaderMaxChars: 75,
      acceptedPdfHeaders: ['{form number}', '{party name}', '{template name}', '{case number}', '{case title}']
    }
  },
  created () {
    if (this.$route.params.id) {
      this.loading = true
      this.getTemplate(this.$route.params.id)
        .then(response => {
          this.loading = false
          this.documentTitle('Form Template > ' + response.name)
        })
    } else {
      this.clearTemplate()
      this.editing = true
      this.documentTitle('New Template')
    }
    for (var i = 0; i < 24; i++) {
      if (i > 12) {
        this.hourArray.push({
          'text': (i - 12) + ':00p',
          'value': i
        })
      } else if (i < 12) {
        this.hourArray.push({
          'text': (i == 0 ? '12' : i) + ':00a',
          'value': i
        })
      } else if (i == 12) {
        this.hourArray.push({
          'text': i + ':00p',
          'value': i
        })
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.$route.params.id = to.params.id
    if (to.params.id) {
      this.getTemplate(to.params.id)
    } else {
      this.clearTemplate()
      this.editing = true
    }
    next()
  },
  computed: {
    ...mapGetters('formtemplate', [
      'template',
      'partById'
    ]),
    ...mapState('formtemplate', [
      'viewArchived',
      'viewIdentifiers'
    ]),
    ...mapGetters('auth', [
      'getDomainInfo',
    ]),
    selectedProvider () {
      if (this.edittemplate.esign_provider) {
        return this.getDomainInfo.esign_providers.find((obj) => obj.key == this.edittemplate.esign_provider)
      }
      return null
    },
    selectedProviderOptions () {
      if (this.edittemplate.esign_provider) {
        var provider = this.selectedProvider
        if ('template_opts' in provider)
          return provider['template_opts']
      }
      return []
    },
    canYouSave(){
      if(this.saving){
        return false
      }
      if(this.edittemplate.header_text){
        if(!this.isPdfHeaderInvalid()){
          if(this.isPdfHeaderTagsInvalid()){
            return false
          }
        }
        else{
          return false
        }
      }
      return this.isSendWhenAddedValid() && this.isSendWhenSubmittedValid() && this.isSendWhenUnopenedValid() && this.isSendWhenStartedValid() && this.isSendWhenSigningValid()
    }
  },
  watch: {
    editing (val) {
      if (val) {
        if (this.template.id)
          this.edittemplate = JSON.parse(JSON.stringify(this.template))
        else
          this.edittemplate = {
            "name": "Test",
            "esign_provider": null,
            "esign_template_settings": {}
          }
        if (this.edittemplate.esign_provider) {
          this.override_default_esign = true
          if (!this.edittemplate.esign_template_settings)
            this.edittemplate.esign_template_settings = {}
        }
      } else if (!this.template.id) {
        this.$router.go(-1)
      }
    },
    casetypeSearch () {
      if(this.casetypeSearch){
          this.fetchCaseTypes()
      }
    }
  },
  methods: {
    ...mapMutations('formtemplate', [
      'clearTemplate'
    ]),
    ...mapActions('formtemplate', [
      'getTemplate',
      'saveTemplate',
      'moveSection',
      'moveParagraph',
      'movePagebreak'
    ]),
    showConditionalOption(option) {
      if ('condition' in option) {
        var conditionValue = option['condition']['value']
        var checkCondition = this.selectedProvider['variables'].find((obj) => obj.key == option['condition']['key'])
        return 'value' in checkCondition ? (checkCondition.value == conditionValue) : false
      }
      return true
    },
    updateOverride() {
      if (!this.override_default_esign) {
        this.edittemplate.esign_provider = null
        this.edittemplate.esign_template_settings = null
      } else {
        this.edittemplate.esign_provider = this.getDomainInfo.default_esign_provider
        this.edittemplate.esign_template_settings = {}
      }
    },
    fetchCaseTypes() {
      api.cases.casetype.list({
        search: this.casetypeSearch
      })
        .then(data => {
          this.casetypeResults = data.results
        })
    },
    updateEsign() {
      if (this.edittemplate.esign_provider == "local") {
        this.edittemplate.sign_on_client_submit = true
      }
    },
    save () {
      this.saving = true
      if (this.edittemplate.notify_new)
        this.edittemplate.new_notification_text = this.$refs.newHtml.getHTML()
      else{
        this.edittemplate.new_notification_subject = ''
        this.edittemplate.new_notification_text = ''
      }
      if (this.edittemplate.notify_started)
        this.edittemplate.started_notification_text = this.$refs.startedHtml.getHTML()
      else{
        this.edittemplate.started_notification_subject = ''
        this.edittemplate.started_notification_text = ''
      }
      if (this.edittemplate.notify_signing)
        this.edittemplate.signing_notification_text = this.$refs.signingHtml.getHTML()
      else{
        this.edittemplate.signing_notification_subject = ''
        this.edittemplate.signing_notification_text = ''
      }
      if (this.edittemplate.notify_on_submit)
        this.edittemplate.submit_notification_message = this.$refs.submitHtml.getHTML()
      else{
        this.edittemplate.submit_notification_subject = ''
        this.edittemplate.submit_notification_message = ''
      }
      if (this.edittemplate.notify_on_add)
        this.edittemplate.add_notification_message = this.$refs.addHtml.getHTML()
      else{
        this.edittemplate.add_notification_subject = ''
        this.edittemplate.add_notification_message = ''
      }
      if (this.edittemplate.stop_notifying_date == "")
        this.edittemplate.stop_notifying_date = null
      this.saveTemplate(this.edittemplate)
      .then(template => {
        this.$router.replace({ name: 'FormTemplate', params: { id: template.id } })
        this.editing = false
        this.saving = false
        this.editFocus = 'general'
      })
    },
    duplicateForm () {
      this.loading = true
      this.copyDialog = false
      this.editing = false
      api.formtemplate.formtemplate.duplicate(this.template, this.duplicateName)
        .then((data) => {
          this.clearTemplate()
          this.$router.replace({ name: 'FormTemplate', params: { id: data.id } })
          this.getTemplate(data.id)
            .then(() => {
              this.loading = false
            }) 
        })
    },
    downloadImportGrid (type = "create") {
      api.formtemplate.formtemplate.downloadImportFile(this.template, type)
        .then(response => {
          this.loading = false
          let blob = new Blob([response.data])
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `${this.template.name}_import.csv`
          link.click()
        })
    },
    newSection () {
      this.newPart = {
        template: this.template.id,
        part_type: 's'
      }
      this.addingNewPart = true
    },
    newParagraph () {
      this.newPart = {
        template: this.template.id,
        part_type: 'p'
      }
      this.addingNewPart = true
    },
    newPageBreak () {
      this.newPart = {
        template: this.template.id,
        part_type: 'b'
      }
      this.addingNewPart = true
    },
    partAdded (part) {
      this.addingNewPart = false
      this.template.root_parts.push(part.id)
    },
    drag(e) {
      this.draggedElement = e.draggedContext.element
    },
    endDrag (event) {
      let movedPart = this.partById(this.draggedElement)
      this.draggedElement = null
      if (movedPart.part_type === 's') {
        this.moveSection({ section: movedPart, toIndex: event.newIndex })
      } else if (movedPart.part_type === 'p') {
        this.moveParagraph({ paragraph: movedPart, toIndex: event.newIndex })
      } else if (movedPart.part_type === 'b') {
        this.movePagebreak({ pagebreak: movedPart, toIndex: event.newIndex })
      } else {
        throw new TypeError('Unsupported part type')
      }
    },
    getRidOfParagraphTags (text){
      return text.replace('<p>', '').replace('</p>', '')
    },
    isSendWhenAddedValid (){
      if(this.editing && this.edittemplate.notify_on_add && this.$refs.addHtml){
        return this.edittemplate.add_notification_subject && this.getRidOfParagraphTags(this.$refs.addHtml.getHTML()) !== ""
      }
      return true
    },
    isSendWhenSubmittedValid (){
      if(this.editing && this.edittemplate.notify_on_submit && this.$refs.submitHtml){
        return this.edittemplate.submit_notification_subject && this.getRidOfParagraphTags(this.$refs.submitHtml.getHTML()) !== ""
      }
      return true
    },
    isSendWhenUnopenedValid (){
      if(this.editing && this.edittemplate.notify_new && this.$refs.newHtml){
        return this.edittemplate.new_notification_subject && this.getRidOfParagraphTags(this.$refs.newHtml.getHTML()) !== ""
      }
      return true
    },
    isSendWhenStartedValid (){
      if(this.editing && this.edittemplate.notify_started && this.$refs.startedHtml){
        return this.edittemplate.started_notification_subject && this.getRidOfParagraphTags(this.$refs.startedHtml.getHTML()) !== ""
      }
      return true
    },
    isSendWhenSigningValid (){
      if(this.editing && this.edittemplate.notify_signing && this.$refs.signingHtml){
        return this.edittemplate.signing_notification_subject && this.getRidOfParagraphTags(this.$refs.signingHtml.getHTML()) !== ""
      }
      return true
    },
    isPdfHeaderInvalid (){
      if(this.edittemplate.header_text.length > this.pdfHeaderMaxChars){
        return true
      }
      let lastBracket = ''
      let charsSinceBracket = 0
      for (const char of this.edittemplate.header_text) {
        if (char == '{' || char == '}') {
          if (lastBracket == '{' && charsSinceBracket == 0) {
            return true
          }
          if (char == lastBracket) {
            return true
          }
          lastBracket = char
          charsSinceBracket = 0
        }
        else {
          charsSinceBracket++
        }
      }
      return this.edittemplate.header_text.split('{').length != this.edittemplate.header_text.split('}').length
    },
    isPdfHeaderTagsInvalid (){
      let header_tags = this.edittemplate.header_text.split( /({[^}]+})/g).filter(item => item !== '' && item[0] === '{')
      if (header_tags.length == 0) { return false }
      let correctTags = 0
      for(const tag of header_tags){
        if (this.acceptedPdfHeaders.includes(tag)) { correctTags++ }
      }
      return header_tags.length != correctTags
    }
  }
}
</script>

<style
  scoped
>
.root-parts {
  margin-top: 10px;
}

.archived {
  opacity: 0.5;
}

.archived:hover {
  opacity: 0.9;
}

.active {
  background: #EFEFEF;
}

.hidden {
  display: none !important;
}

.block-header {
  width:100%;
  padding-bottom: 10px;
  border-bottom: 1px solid #262626;
}
</style>
